import { Link } from '@apollo/orbit';
import moment from 'moment';
import React from 'react';

import { format } from 'src/lib/format';
import { DocsRouter } from 'src/lib/routers';

import {
  CurrentFieldAccessBounds,
  CurrentFieldEmptyState,
} from '../../useCurrentField';

interface Props {
  accessBounds: CurrentFieldAccessBounds;
  emptyState: CurrentFieldEmptyState;
}

export const NoFieldUsage = ({ accessBounds, emptyState }: Props) => (
  <div className="text-center text-secondary">
    <p className="pb-2 text-xl font-semibold">
      There are no metrics for this field
    </p>
    <div className="max-w-md">
      {emptyState.clientAndOperationMetricsDisabled ? (
        <div data-testid="no-field-usage">
          Client and operation metrics for fields are disabled for your graph.
        </div>
      ) : !emptyState.variantHasUsage ? (
        <div data-testid="no-variant-usage">
          <p className="mt-3">
            Your graph is not reporting usage information to Studio.
          </p>
          <p className="mt-3">
            Configure metrics observability in your server to see usage and
            health information for fields.
          </p>
          <p className="mt-3">
            For details, see the{' '}
            <Link isExternal to={DocsRouter.path('FieldsUsage')}>
              Studio Documentation
            </Link>
          </p>
        </div>
      ) : emptyState.fieldUsageOutsideTimeBounds &&
        emptyState.fieldEarliestRetentionInDays ? (
        <div data-testid="usage-out-of-bounds-since">
          Your graph's server has not reported any usage of this field in the
          selected time range (last seen{' '}
          {moment(accessBounds?.lastSeen).format('MMM Do')}).
        </div>
      ) : emptyState.fieldUsageOutsideTimeBounds ? (
        <div data-testid="usage-out-of-bounds">
          Your graph's server has not reported any usage of this field in the
          selected time range.
        </div>
      ) : !emptyState.fieldHasUsage &&
        emptyState.fieldEarliestRetentionInDays ? (
        <div data-testid="no-field-usage-since">
          Your graph's server has not reported any usage of this field in the
          last {emptyState.fieldEarliestRetentionInDays}{' '}
          {format.pluralize(emptyState.fieldEarliestRetentionInDays, 'day')}.
        </div>
      ) : (
        <div data-testid="no-field-usage">
          Your graph's server has not reported any usage of this field.
        </div>
      )}
    </div>
  </div>
);
